module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/The-Stuarts-A-Bloody-Reign.e08b0a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/The-Stuarts-A-Bloody-Reign.jpg
// module id = 8WpX
// module chunks = 0